{
  "infoStocksStatistics": {
    "title": "Statistics",
    "error": "Failed to load company statistics",
    "marketCap": "Market capitalization",
    "peRatio": "Price to earnings Ratio (TTM)",
    "netIncome": "Net income",
    "sharesFloat": "Shares float",
    "dividendYield": "Dividend yield (indicated)",
    "epsBasic": "Basic EPS (TTM)",
    "revenue": "Revenue",
    "beta": "Beta"
  }
}
